import * as React from 'react'
import { ReactElement } from 'react'
import { useFormikContext } from 'formik'
import ReportForm from './ReportForm'
import BaseDropdown from '../../../../components/Dropdown/BaseDropdown'
import { getDropdownProps } from '../../../../helpers/formHelper'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export type OutstandingInvoices = {
    showAll: string
    groupByOwner: string
}

function ReportBody(props: ReportFormType): ReactElement {
    const { values, setFieldValue } = useFormikContext<OutstandingInvoices>()
    return (
        <>
            <BaseDropdown
                {...getDropdownProps(values.showAll, undefined, value => setFieldValue('showAll', value), false)}
                required
                label={'Toon alleen vervallen'}
                canClear={false}
                options={[
                    { key: 'true', text: 'Nee' },
                    { key: 'false', text: 'Ja' },
                ]}
            />
            <BaseDropdown
                {...getDropdownProps(values.groupByOwner, undefined, value => setFieldValue('groupByOwner', value), false)}
                required
                label={'Groepering per verantwoordelijke'}
                canClear={false}
                options={[
                    { key: 'true', text: 'Ja' },
                    { key: 'false', text: 'Nee' },
                ]}
            />
        </>
    )
}

export default function OutstandingInvoicesForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<OutstandingInvoices>
            title="Openstaande declaraties"
            generationType={DocumentGenerationType.OutstandingInvoices}
            initialValues={{
                showAll: 'true',
                groupByOwner: 'false',
            }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
